import useApi from '../hook/useApi';

const useTicketApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const refresTicket = async (status, page = 1) => {
    return sendRequest(`/imp/tickets_screen/get_all_ticket?status=${status}&page=${page}`, 'GET', {});
  };

  const updateTicket = async (id, payload) => {
    //"accept", "schedule", "complete"
    return sendRequest(`/imp/tickets_screen/update_ticket/${id}`, 'PUT', payload);
  };

  const addTicket = async (payload) => {
    //"accept", "schedule", "complete"
    return sendRequest(`/imp/tickets_screen/add_ticket`, 'POST', payload);
  };

  return {
    refresTicket,
    updateTicket,
    addTicket,
    loading,
    data,
    error,
  };
};

export default useTicketApi;